module.exports = __webpack_public_path__ + "media/images/navico_logo-9fcf6a30796c0e666cddf1d3f0edb3e0.png";